export default {
    delivery: {
        product: {
            tracking: "追踪",
            quantity: "数量"
        }
    }
}